import { Tweet } from 'react-twitter-widgets';
import { type PinRendererProps } from './pinMediaRenderer';
import { UnknownPin } from './UnknownPin';

export function TweetPin(props: PinRendererProps) {
  const tweetId = props.pin.url?.split('/status/')[1];
  if (!tweetId) return <UnknownPin />;
  return (
    <div className="w-full max-w-[550px]">
      <Tweet tweetId={tweetId} />
    </div>
  );
}
